import { Injectable, ConstructorSansProvider } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { PrepasDisponibles, ProduitForfait, ProduitForfaitInfo,
        ServicesEcolesDisponibles, ServiceEcoleInfo, Forfait, B2b, Colonne, CoursId,
        InscriptionId, InstanceEtProduit } from '../models/produit.model';
import { CandidatureForm, Prof } from '../models/personne.model';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ProduitService {
    apiUrl = environment.apiUrl;

    colonnes: Colonne[];
    prepasDisponibles: PrepasDisponibles[];
    produitForfait: ProduitForfait[];
    produitForfaitInfo: ProduitForfaitInfo;
    classe: string;
    classes: Array<{id_classe: string, nom_classe: string}>;
    stageFormsResponse: any;
    prepaFormsResponse: any;
    prof: Prof;
    servicesEcoles: ServicesEcolesDisponibles[];
    serviceEcole: ServiceEcoleInfo;
    forfait: Forfait;
    b2b: B2b;
    instance: ProduitForfaitInfo | ServiceEcoleInfo;
    instanceEtProduit: InstanceEtProduit;
    coursId: CoursId;
    inscriptionId: InscriptionId;
    lastLocation = {code_postal: '', ville: ''};
    candidature: any;

    constructor(private http: HttpClient) { }

    setLastLocation(location: {code_postal: string, ville: string}) {
        this.lastLocation = location;
    }

    getLastLocation() {
        return this.lastLocation;
    }

    getColonnes(): Observable<Colonne[]> {
        return this.http.get(`${this.apiUrl}/colonnes`).pipe(
            map((res) => {
                this.colonnes = res['data'];
                return this.colonnes;
            }),
        catchError(this.handleError));
    }

    getInstanceIds(url_instance: string): Observable<any> {
        const params = new HttpParams().set('url_instance', url_instance);
        return this.http.get(`${this.apiUrl}/idInstance`, {params: params}).pipe(
            map((res) => {
                this.instance = res['data'];
                return this.instance;
            }),
        catchError(this.handleError));
    }

    getInstanceEtProduit(url_instance: string): Observable<any> {
        const params = new HttpParams().set('url_instance', url_instance);
        return this.http.get(`${this.apiUrl}/instance_et_produit`, {params: params}).pipe(
            map((res) => {
                this.instanceEtProduit = res['data'];
                return this.instanceEtProduit;
            }),
        catchError(this.handleError));
    }

    getInstanceEtProduitFromOffre(id_offre_emploi: string): Observable<any> {
        const params = new HttpParams().set('id_offre_emploi', id_offre_emploi);
        return this.http.get(`${this.apiUrl}/instance_et_produit`, {params: params}).pipe(
            map((res) => {
                this.instanceEtProduit = res['data'];
                return this.instanceEtProduit;
            }),
        catchError(this.handleError));
    }

    sendCandidatureForm(candidatureForm: CandidatureForm): Observable<any> {
        return this.http.post(`${this.apiUrl}/candidature_form`, { data: candidatureForm })
          .pipe(map((res) => {
            this.candidature = res['data'];
            return this.candidature;
          }),
          catchError(this.handleError));
    }

    getForfait(id_forfait: string): Observable<Forfait> {
        const params = new HttpParams().set('id_forfait', id_forfait);
        return this.http.get(`${this.apiUrl}/forfait`, {params: params}).pipe(
            map((res) => {
                this.forfait = res['data'];
                return this.forfait;
            }),
        catchError(this.handleError));
    }

    getB2b(id_b2b: string): Observable<B2b> {
        const params = new HttpParams().set('id_b2b', id_b2b);
        return this.http.get(`${this.apiUrl}/b2b`, {params: params}).pipe(
            map((res) => {
                this.b2b = res['data'];
                return this.b2b;
            }),
        catchError(this.handleError));
    }

    getProf(id_prof): Observable<Prof> {
        const params = new HttpParams().set('id_prof', id_prof);
        return this.http.get(`${this.apiUrl}/prof`, {params: params}).pipe(
            map((res) => {
                this.prof = res['data'];
                return this.prof;
            }),
        catchError(this.handleError));
    }

    getProduitForfait(): Observable<ProduitForfait[]> {
        return this.http.get(`${this.apiUrl}/produit_forfait`).pipe(
            map((res) => {
                this.produitForfait = res['data'];
                return this.produitForfait;
            }),
        catchError(this.handleError));
    }

    getPrepasDisponibles(mot_clef: string): Observable<PrepasDisponibles[]> {
        const params = new HttpParams().set('mot_clef', mot_clef);
        return this.http.get(`${this.apiUrl}/prepas_disponibles`, {params: params}).pipe(
            map((res) => {
                this.prepasDisponibles = res['data'];
                return this.prepasDisponibles;
            }),
        catchError(this.handleError));
    }

    getPrepaById(id_instance): Observable<ProduitForfaitInfo> {
        const params = new HttpParams().set('id_instance', id_instance);
        return this.http.get(`${this.apiUrl}/prepa`, {params: params}).pipe(
            map((res) => {
                this.produitForfaitInfo = res['data'];
                return this.produitForfaitInfo;
            }),
        catchError(this.handleError));
    }

    getServiceEcole(mot_clef: string): Observable<ServicesEcolesDisponibles[]> {
        const params = new HttpParams().set('mot_clef', mot_clef);
        return this.http.get(`${this.apiUrl}/services_ecoles_disponibles`, {params: params}).pipe(
            map((res) => {
                this.servicesEcoles = res['data'];
                return this.servicesEcoles;
            }),
        catchError(this.handleError));
    }

    getServiceEcole1(): Observable<ServicesEcolesDisponibles[]> {
        const params = new HttpParams().set('column_number', '1');
        return this.http.get(`${this.apiUrl}/services_ecoles_disponibles`, {params: params}).pipe(
            map((res) => {
                this.servicesEcoles = res['data'];
                return this.servicesEcoles;
            }),
        catchError(this.handleError));
    }

    getServiceEcole2(): Observable<ServicesEcolesDisponibles[]> {
        const params = new HttpParams().set('column_number', '2');
        return this.http.get(`${this.apiUrl}/services_ecoles_disponibles`, {params: params}).pipe(
            map((res) => {
                this.servicesEcoles = res['data'];
                return this.servicesEcoles;
            }),
        catchError(this.handleError));
    }

    getServiceEcole3(): Observable<ServicesEcolesDisponibles[]> {
        const params = new HttpParams().set('column_number', '3');
        return this.http.get(`${this.apiUrl}/services_ecoles_disponibles`, {params: params}).pipe(
            map((res) => {
                this.servicesEcoles = res['data'];
                return this.servicesEcoles;
            }),
        catchError(this.handleError));
    }

    getServiceEcoleById(id_instance: string): Observable<ServiceEcoleInfo> {
        const params = new HttpParams().set('id_instance', id_instance);
        return this.http.get(`${this.apiUrl}/service_ecole`, {params: params}).pipe(
            map((res) => {
                this.serviceEcole = res['data'];
                return this.serviceEcole;
            }),
        catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }
}
